let index: number = 0

const RequestForMovementPartyGridPluginSettings: IPluginSettings = {
    name: "Партии",
    mnemocode: "request_for_movement_party_plugin",
    permission: "RequestForMovement",
    columns: [
        {
            order: index++,
            propertyName: "idGlobal",
            propertyType: "string",
            displayName: "idGlobal",
            visibility: false,
            width: 200,
        }, 
        {
            order: index++,
            propertyName: "lots",
            propertyType: "string",
            displayName: "Связанная партия",
            visibility: true,
            width: 200,
        }, 
        {
            order: index++,
            propertyName: "idLotGlobal",
            propertyType: "string",
            displayName: "ID партии",
            visibility: false,
            width: 200,
        }, 
        {
            order: index++,
            propertyName: "quantitySent",
            propertyType: "string",
            displayName: "Количество партии",
            visibility: true,
            width: 200,
        }, 
        {
            order: index++,
            propertyName: "substanceName",
            propertyType: "string",
            displayName: "МНН (рус.)",
            visibility: true,
            width: 200,
        }, 
        {
            order: index++,
            propertyName: "substanceNameLat",
            propertyType: "string",
            displayName: "МНН (лат.)",
            visibility: false,
            width: 200,
        }, 
        {
            order: index++,
            propertyName: "tradeName",
            propertyType: "string",
            displayName: "ТН (рус.)",
            visibility: true,
            width: 200,
        }, 
        {
            order: index++,
            propertyName: "tradeNameLat",
            propertyType: "string",
            displayName: "ТН (лат.)",
            visibility: false,
            width: 200,
        }, 
        {
            order: index++,
            propertyName: "quantity",
            propertyType: "string",
            displayName: "Количество в заявке",
            visibility: true,
            width: 200,
        }, 
        {
            order: index++,
            propertyName: "cureFormName",
            propertyType: "string",
            displayName: "Лек. форма",
            visibility: true,
            width: 200,
        }, 
        {
            order: index++,
            propertyName: "dosage",
            propertyType: "string",
            displayName: "Дозировка",
            visibility: true,
            width: 200,
        }, 
        {
            order: index++,
            propertyName: "nFv",
            propertyType: "string",
            displayName: "Фасовка",
            visibility: true,
            width: 200,
        },
    ],
}

export default RequestForMovementPartyGridPluginSettings
